<template>
  <v-card fill-height>
      <DialogNotice ref="dlg"></DialogNotice>
      <v-layout row>
        <v-flex xs12>
          <v-container>
            <span class="headline font-weight-thin bluetext">{{'TITLE_DOCS_DOWNLOAD' | translate}}</span>
            <SelectConfigurationList ref="sList" v-model="configName" v-if="tableData" :rk="tableData.commonRkNr"
                                     :guvNr="tableData.commonGuvNr"></SelectConfigurationList>
            <v-layout row wrap justify-space-around class="ma-4" v-if="configExcel">
              <v-flex xs12 sm6>
                <v-layout row>
                  <v-flex xs6 sm6 md4>
                    <v-checkbox
                      color="#004884"
                      :readonly="isReadOnly"
                      :label='configExcelLabel' v-model='configExcel.excelSheetStammdaten' :value=1
                    ></v-checkbox>
                    <v-checkbox
                      color="#004884"
                      :label='excelSheetStrukturbilanzLabel' v-model='configExcel.excelSheetStrukturbilanz' :value=1
                    ></v-checkbox>
                    <v-checkbox
                      color="#004884"
                      v-if="!isPeergroup"
                      :label='excelSheetRohbilanzLabel' v-model='configExcel.excelSheetRohbilanz' :value=1
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6 sm6 md4>
                    <v-checkbox
                      color="#004884"
                      :label='excelSheetKennzahlenLabel' v-model='configExcel.excelSheetKennzahlen' :value=1
                    ></v-checkbox>
                    <v-checkbox
                      color="#004884"
                      v-if="!isBank && !isPeergroup && (isBR && isBR.active === 1)"
                      :label='excelSheetBilanzratingLabel' v-model='configExcel.excelSheetBilanzrating' :value=1
                    ></v-checkbox>
                    <v-checkbox
                      color="#004884"
                      v-if="!isBank && !isPeergroup && (isKDF && isKDF.active === 1)"
                      :label='excelSheetKDFLabel' v-model='configExcel.excelSheetKDF' :value=1
                    ></v-checkbox>
                    <v-checkbox
                      color="#004884"
                      v-if="isBank && !isPeergroup"
                      :label='excelSheetVerflechtung' v-model='configExcel.excelSheetVerflechtung' :value=1
                    ></v-checkbox>
                    <v-checkbox
                      color="#004884"
                      v-if="(isBank && !isPeergroup) && (isBS && isBS.active === 1)"
                      :label='excelSheetKDFBankscore' v-model='configExcel.excelSheetBankscore' :value=1
                    ></v-checkbox>
                    <v-checkbox
                      color="#004884"
                      v-if="isBank && showPG2"
                      :label='excelSheetPG2BILANZLabel' v-model='configExcel.excelSheetPG2BILANZ' :value=1
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm4>
                <v-layout row wrap justify-space-around>
                  <v-flex shrink
                          v-for="item in excelList" :key="item.name" :class="'moduleButton pointer ' + item.id"
                          @click="download(item)"
                          class="mb-5"
                  >
                    <v-card
                      flat
                      color="transparent"
                    >
                      <v-hover>
                        <v-img height="107" width="251" slot-scope="{ hover }" :src="getImageUrl(item, hover)">
                          <v-layout pa-2 column fill-height class="title font-weight-regular">
                            <v-spacer></v-spacer>
                            <v-flex shrink>
                              <span :class="'Textcolor ' + hover + 'Hover'">{{item.name}}</span>
                            </v-flex>
                          </v-layout>
                        </v-img>
                      </v-hover>


                    </v-card>
                  </v-flex>
                  <!--<v-flex shrink v-for="doc in documents" :key="doc.id"
                          v-if="!isPeergroup"
                          :class="'moduleButton downloadDoc' + doc.DokumententypNr"
                          @click="downloadPDF(doc)"
                  >
                    <v-card
                      flat
                      color="transparent"
                    >
                      <v-hover>
                        <v-img height="107" width="251" slot-scope="{ hover }" :src="getPDFURL(hover)">
                          <v-layout pa-2 column fill-height class="title font-weight-regular">
                            <v-spacer></v-spacer>
                            <v-flex shrink>
                              <span :class="'Textcolor ' + hover + 'Hover'">{{doc.title}}</span>
                            </v-flex>
                          </v-layout>
                        </v-img>
                      </v-hover>
                    </v-card>
                  </v-flex>-->
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    <v-flex xs12>
      <v-divider></v-divider>
    </v-flex>
      <v-layout row>
        <v-flex xs12>
          <v-container v-if="(!isPeergroup) && (documents && documents.length > 0)">
            <span class="headline font-weight-thin bluetext">{{'TITLE_DOCS_DOWNLOAD_PDF' | translate}}</span>
            <v-layout row wrap justify-space-around class="ma-4">
              <v-flex shrink v-for="doc in documents" :key="doc.id"
                      v-if="!isPeergroup"
                      :class="'moduleButton downloadDoc' + doc.DokumententypNr"
                      @click="downloadPDF(doc)"
              >
                <v-card
                  flat
                  color="transparent"
                >
                  <v-hover>
                    <v-img height="107" width="251" slot-scope="{ hover }" :src="getPDFURL(hover)">
                      <v-layout pa-2 column fill-height class="title font-weight-regular">
                        <v-spacer></v-spacer>
                        <v-flex shrink>
                          <span :class="'Textcolor ' + hover + 'Hover'">{{doc.title}}</span>
                        </v-flex>
                      </v-layout>
                    </v-img>
                  </v-hover>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-container v-if="(!isPeergroup) && (exportFormats && exportFormats.length > 0)">
          <span class="headline font-weight-thin bluetext">{{'TITLE_DOCS_DOWNLOAD_EXPORT_FORMATS' | translate}}</span>
          <v-layout row wrap justify-space-around class="ma-4">
            <v-flex shrink v-for="(doc, ii) in exportFormats" :key="ii"
                    :class="'moduleButton exportFormat' + doc.BilanztypNr"
                    @click="downloadExportFormat(doc)"
            >
              <v-card
                flat
                color="transparent"
              >
                <v-hover>
                  <v-img height="107" width="251" slot-scope="{ hover }" :src="getPDFURL(hover)">
                    <v-layout pa-2 column fill-height class="title font-weight-regular">
                      <v-spacer></v-spacer>
                      <v-flex shrink>
                        <span :class="'Textcolor ' + hover + 'Hover'">{{doc.Bezeichnung}}</span>
                      </v-flex>
                    </v-layout>
                  </v-img>
                </v-hover>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  import Vue from 'vue'
  var _ = require('lodash')
  import swal from 'sweetalert2'
  import SelectConfigurationList from './../../widgets/SelectConfigurationList'
  import TrafficLight from "../../widgets/TrafficLight";
  import DF from "dateformat";
  import DialogNotice from './../../module/dialogs/DialogNotice'

  export default {
    name: 'TabDokumente',
    props: ['data', 'balance', 'isPeergroup', 'isBank', 'balanceArray', 'sdTitle', 'tabData'],
    components: {TrafficLight, SelectConfigurationList, DialogNotice},
    methods: {
      onDownloadError: function (data) {
        Vue.prototype.$api.debug('onDownloadError', data)
        Vue.prototype.$api.hideIdle()
        swal(Vue.i18n.translate('DIALOG_TEXT_ERROR_DOWNLOAD_DOCUMENT'))
      },
      onDownloaded: function (data) {
        Vue.prototype.$api.debug('onDownloaded', data)
        Vue.prototype.$api.hideIdle()
      },
      open: function (data) {
        Vue.prototype.$eventHub.$emit('OnGetExcelConfig', this.configExcel)
        this.tableData = _.clone(data)
        this.reload()
      },
      downloadExportFormat: function (document) {
        if (!Vue.prototype.$api.hasProduct('hasRightExport')) {
          Vue.prototype.$api.debug('missing right to export files')
          this.$refs.dlg.show({
            title: Vue.i18n.translate('DIALOG_TITLE_MISSING_HAS_EXPORT'),
            text: Vue.i18n.translate('DIALOG_TEXT_MISSING_HAS_EXPORT')
          })
          return
        }
        Vue.prototype.$api.showIdle()
        var cmp = this
        Vue.prototype.$api.downloadBilanzFile({
          type: 'POST-BILANZ_EXPORT',
          balance: cmp.balance,
          fileName: Vue.i18n.translate('EXPORTFORMAT_FNAME_BT_' + document.BilanztypNr),
          bilanztypNr: document.BilanztypNr,
          extension: 'xml'
        })
      },
      downloadPDF: function (document) {
        if (!Vue.prototype.$api.hasProduct('hasRightExport')) {
          Vue.prototype.$api.debug('missing right to export files')
          this.$refs.dlg.show({
            title: Vue.i18n.translate('DIALOG_TITLE_MISSING_HAS_EXPORT'),
            text: Vue.i18n.translate('DIALOG_TEXT_MISSING_HAS_EXPORT')
          })
          return
        }

        Vue.prototype.$api.showIdle()
        var cmp = this
        if (document.DokumententypNr === '22') {
          Vue.prototype.$api.downloadPDFReport({
            balance: cmp.balance,
            fileName: Vue.i18n.translate('PDF_BILANZ_REPORT_FILENAME'),
            auftragNr: document.AuftragNr,
            dokumententypNr: document.DokumententypNr
          })
        } else {
          var excelConfig = {
            type: document.DokumententypNr,
            bankName: cmp.sdTitle,
            configName: document.DokumententypNr + '_pdf.pdf'
          }
          if (document.DokumententypNr === '3') {
            excelConfig.fileName = Vue.i18n.translate('PDF_FS_REPORT_FILENAME') + '_' + cmp.sdTitle + '_' + this.year
          } else if (document.DokumententypNr === '11') {
            excelConfig.fileName = Vue.i18n.translate('PDF_DCR_REPORT_FILENAME') + '_' + cmp.sdTitle + '_' + this.year
          }
          Vue.prototype.$api.downloadPDF(excelConfig, document.AuftragNr, document.DokumententypNr)
        }
      },

      onGetDocuments: function (data) {
        Vue.prototype.$api.debug('onGetDocuments', data)
        if (this.$refs.sList) {
          this.$refs.sList.reload({
            rk: data.commonRkNr,
            guvNr: data.commonGuvNr
          })
        }
        if (data.list) {
          for (var i in data.list) {
            var d = data.list[i]
            d.id = i
            d.title = Vue.i18n.translate('CHANGE_LOG_DOWNLOAD_DOC_TITLE_' + d.DokumententypNr)
          }
        }
        this.documents = data.list
        var cmp = this
        if (Vue.prototype.$api.getModuleId() === 'companies') {
          Vue.prototype.$api.checkReportExists({
            balance: cmp.balance,
            auftragNr: document.AuftragNr,
            dokumententypNr: document.DokumententypNr
          }, this.onGetReportData)
        }
      },
      download: function (item) {
        Vue.prototype.$api.debug('download', item)
        if (!Vue.prototype.$api.hasProduct('hasRightExport')) {
          Vue.prototype.$api.debug('missing right to export files')
          this.$refs.dlg.show({
            title: Vue.i18n.translate('DIALOG_TITLE_MISSING_HAS_EXPORT'),
            text: Vue.i18n.translate('DIALOG_TEXT_MISSING_HAS_EXPORT')
          })
          return
        }

        Vue.prototype.$api.showIdle()
        this.configExcel.configName = this.configName
        if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
          this.configExcel.SAcompany = ''
          this.configExcel.SAcompany = Vue.prototype.$api.balanceToString(Vue.prototype.storage.ankerBankBalance)
        }

        this.configExcel.SAcompany = ''
        if (this.balance) {
          this.configExcel.SAcompany = Vue.prototype.$api.balanceToString(this.balance)
        }

        if (this.isPeergroup) {
          if (!Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
            this.configExcel.SAcompany = ''
          }

          this.configExcel.SApeergroup = ''
          for (var index in this.balanceArray) {
            var balance = this.balanceArray[index]
            var bString = balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
            if (bString !== this.configExcel.SAcompany) {
              this.configExcel.SApeergroup += bString + ','
            }
          }
          this.configExcel.SApeergroup = this.configExcel.SApeergroup.substr(0, this.configExcel.SApeergroup.length - 1)
        }
        if (this.isPeergroup) {
          if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
            this.configExcel.fileName = Vue.i18n.translate('TITLE_DOCUMENT_DOWNLOAD_PEERGROUP') + '_' + Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()).crefoNr + '_'
            this.configExcel.fileName += this.getCountBanks() + '_'
            this.configExcel.fileName = this.getFileName(this.configExcel.fileName)
          } else {
            this.configExcel.fileName = Vue.i18n.translate('TITLE_DOCUMENT_DOWNLOAD_PEERGROUP') + '_'
            this.configExcel.fileName += this.balanceArray.length + '_'
            this.configExcel.fileName = this.getFileName(this.configExcel.fileName)
          }
        } else {
          this.configExcel.fileName = Vue.i18n.translate('TITLE_DOCUMENT_DOWNLOAD')
          this.configExcel.fileName = this.getFileName(this.configExcel.fileName)
        }
        this.configExcel.excelSheetVerflechtungHierarchisch = this.configExcel.excelSheetVerflechtung
        console.log(this.configExcel, this.configExcel.excelSheetStrukturbilanz)
        Vue.prototype.storage.saveState(this.keyPrefix + 'excelSheetStammdaten', this.configExcel.excelSheetStammdaten)
        Vue.prototype.storage.saveState(this.keyPrefix + 'excelSheetStrukturbilanz', this.configExcel.excelSheetStrukturbilanz)
        Vue.prototype.storage.saveState(this.keyPrefix + 'excelSheetRohbilanz', this.configExcel.excelSheetRohbilanz)
        Vue.prototype.storage.saveState(this.keyPrefix + 'excelSheetKennzahlen', this.configExcel.excelSheetKennzahlen)
        Vue.prototype.storage.saveState(this.keyPrefix + 'excelSheetVerflechtung', this.configExcel.excelSheetVerflechtung)
        Vue.prototype.storage.saveState(this.keyPrefix + 'excelSheetBankscore', this.configExcel.excelSheetBankscore)
        Vue.prototype.storage.saveState(this.keyPrefix + 'excelSheetBilanzrating', this.configExcel.excelSheetBilanzrating)
        Vue.prototype.storage.saveState(this.keyPrefix + 'excelSheetPG2BILANZ', this.configExcel.excelSheetPG2BILANZ)
        Vue.prototype.storage.saveState(this.keyPrefix + 'excelSheetKDF', this.configExcel.excelSheetKDF)

        if (this.showPG2) {
          Vue.prototype.storage.saveState('PG2Defaultexport', this.configExcel.excelSheetPG2BILANZ)
        } else {
          this.configExcel.excelSheetPG2BILANZ = 0
        }
        Vue.prototype.$api.exportFileToExcel(this.configExcel, this.onDownloaded, this.onDownloadError)
      },

      getCountBanks() {
        var cnt = this.balanceArray.length
        if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
          cnt = cnt - 1
        }
        return cnt
      },
      getFileName: function (v) {
        var title = v
        var today = new Date();
        var dStr = DF(today, 'yyyymmdd')
        if (!this.isPeergroup) {
          dStr = '_' + this.balance.crefoNr + '_' + DF(today, 'yyyymmdd')
        }
        return title + dStr
      },

      getPDFURL: function (hover) {
        if (!hover) {
          return 'static/downloads.png'
        }
        return 'static/downloads_hover.png'
      },
      onGetReportData(data) {
        console.log('onGetReportData', data)
        if (data && data.reportFound) {
          if (!this.isBank) {
            if (!this.documents) {
              this.documents = []
            }
            this.documents.push({
              id: '11',
              DokumententypNr: '22',
              title: Vue.i18n.translate('DOWNLOAD_REPORT_TITLE')
            })
          }
        }
        console.log('onGetReportData', this.documents)
      },
      onGetExportFormats: function (data) {
        Vue.prototype.$api.hideIdle()
        this.exportFormats = data.array
      },
      onGetData: function (data) {
        Vue.prototype.$api.hideIdle()
        var orderList = [];
        for (var i in data) {
          var item = data[i]
          orderList.push(item.auftragNr)
        }
        Vue.prototype.$api.debug("getDocuments", orderList)
        Vue.prototype.$api.getDocuments(this.balance, orderList, this.onGetDocuments)

      },
      getImageUrl: function (item, hover) {
        if (!hover) {
          return 'static/' + item.id + '.png'
        }
        return 'static/' + item.id + '_hover.png'
      },
      reload: function () {
        var cmp = this
        Vue.prototype.$api.debug('reload docs', this.balance)
        Vue.prototype.$api.debug('reload docs', cmp.data)
        Vue.prototype.$api.showIdle()
        if (this.$refs.sList) {
          this.$refs.sList.reload({
            rk: cmp.data.commonRkNr,
            guvNr: cmp.data.commonGuvNr
          })
        }
        if (this.isPeergroup) {
          Vue.prototype.$api.createOrderNumbersWithBalanceArray(this.balanceArray, this.onGetData)
        } else {
          var cmp = this
          Vue.prototype.$api.createOrderNumbersWithBalance(this.balance, this.onGetData)
        }
        // clientNr 148
        if ((Vue.prototype.$api.getParamData().clientNr + '') === '361') {
          // KFW
          this.showPG2 = true
          this.configExcel.excelSheetPG2BILANZ = Vue.prototype.storage.getState('PG2Defaultexport', 1)
        } else if ((Vue.prototype.$api.getParamData().clientNr + '') === '148') {
          // externes Rating
          this.showPG2 = true
          this.configExcel.excelSheetPG2BILANZ = Vue.prototype.storage.getState('PG2Defaultexport', 1)
        } else {
          this.configExcel.excelSheetPG2BILANZ = 0
        }
        this.isReadOnly = ('' + window.edoUserId) === '361'
        this.year = '' + this.$route.params.year
        this.keyPrefix = '_'
        if (this.isBank) {
          this.keyPrefix += 'bank'
        }
        if (this.isPeergroup) {
          this.keyPrefix += 'PG'
        }
        this.configExcel.excelSheetStammdaten = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetStammdaten', 1)
        this.configExcel.excelSheetStrukturbilanz = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetStrukturbilanz', 1)
        this.configExcel.excelSheetRohbilanz = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetRohbilanz', 1)
        this.configExcel.excelSheetKennzahlen = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetKennzahlen', 1)
        this.configExcel.excelSheetVerflechtung = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetVerflechtung', 1)
        this.configExcel.excelSheetBankscore = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetBankscore', 1)
        this.configExcel.excelSheetBilanzrating = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetBilanzrating', 1)
        this.configExcel.excelSheetPG2BILANZ = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetPG2BILANZ', 1)
        this.configExcel.excelSheetKDF = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetKDF', 1)

        if (this.isBank) {
          this.configExcel.excelSheetBilanzrating = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetBilanzrating', 0)
          this.configExcel.excelSheetKDF =  Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetKDF', 0)
          if (this.isPeergroup) {
            this.configExcel.excelSheetVerflechtungHierarchisch = 0
            this.configExcel.excelSheetVerflechtung = 0
          }
        } else {
          this.configExcel.excelSheetBankscore = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetBankscore', 0)
          this.configExcel.excelSheetVerflechtung = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetVerflechtung', 0)
        }
        if (this.isPeergroup) {
          this.configExcel.excelSheetBilanzrating = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetBilanzrating', 0)
          this.configExcel.excelSheetKDF = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetKDF', 0)
          this.configExcel.excelSheetVerflechtung = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetVerflechtung', 0)
          this.configExcel.excelSheetBankscore = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetBankscore', 0)
          this.configExcel.excelSheetRohbilanz = Vue.prototype.storage.getState(this.keyPrefix + 'excelSheetRohbilanz', 0)
        }
        Vue.prototype.$api.getExportFormats(this.balance, this.onGetExportFormats)
        this.$nextTick(function () {
          cmp.isBS = cmp.getTabData('BANKENSCORE')
          if (!cmp.isBS || (cmp.isBS.active === 0)) {
            this.configExcel.excelSheetBankscore = 0
          }
          cmp.isBR = cmp.getTabData('BILANZRATING')
          if (!cmp.isBR || (cmp.isBR.active === 0)) {
            this.configExcel.excelSheetBilanzrating = 0
          }
          cmp.isKDF = cmp.getTabData('KDF')
          if (!cmp.isKDF || (cmp.isKDF.active === 0)) {
            this.configExcel.excelSheetKDF = 0
          }

        })

      },
      getTabData: function (name) {
        let res = null
        _.each(this.tabData, function (v) {
          if (v.id === name) {
            res = v
          }
        })
        console.log('getTabData', name, res)
        return res
      }
    },
    data() {
      return {
        exportFormats: [],
        tableData: null,
        documents: [],
        configName: '',
        isReadOnly: false,
        year: 2016,
        configExcelLabel: Vue.i18n.translate('DOWNLOAD_STAMMDATEN'),
        excelSheetStrukturbilanzLabel: Vue.i18n.translate('DOWNLOAD_STRUKTUR'),
        excelSheetRohbilanzLabel: Vue.i18n.translate('DOWNLOAD_ROH'),
        excelSheetKennzahlenLabel: Vue.i18n.translate('DOWNLOAD_KENNZAHLEN'),
        excelSheetBilanzratingLabel: Vue.i18n.translate('DOWNLOAD_BILANZ'),
        excelSheetPG2BILANZLabel: Vue.i18n.translate('DOWNLOAD_PG2BILANZ'), // Banken module
        excelSheetKDFLabel: Vue.i18n.translate('DOWNLOAD_KDF'),
        excelSheetVerflechtung: Vue.i18n.translate('TAB_VERFLECHTUNG'),
        excelSheetKDFBankscore: Vue.i18n.translate('TAB_BANKSCORE'),
        configExcel: null,
        isBR: null,
        isBS: null,
        isKDF: null,
        showPG2: false,
        excelList: [{
          name: Vue.i18n.translate('DOWNLOAD_EXCEL'),
          type: 'EXCEL-STRUCT',
          id: 'downloads'
        }]
      }
    },
    mounted() {
      this.configExcel = {
        excelSheetStammdaten: 1,
        excelSheetStrukturbilanz: 1,
        excelSheetRohbilanz: 1,
        excelSheetKennzahlen: 1,
        excelSheetVerflechtung: 1,
        excelSheetBankscore: 1,
        excelSheetBilanzrating: 1,
        excelSheetPG2BILANZ: 0,
        excelSheetKDF: 1,
        type: 'EXCEL-STRUCT'
      }
      // clientNr 148
      if ((Vue.prototype.$api.getParamData().clientNr + '') === '361') {
        // KFW
        this.showPG2 = true
        this.configExcel.excelSheetPG2BILANZ = Vue.prototype.storage.getState('PG2Defaultexport', 1)
      } else if ((Vue.prototype.$api.getParamData().clientNr + '') === '1') {
        // externes Rating
        this.showPG2 = true
        this.configExcel.excelSheetPG2BILANZ = Vue.prototype.storage.getState('PG2Defaultexport', 1)
      } else if ((Vue.prototype.$api.getParamData().clientNr + '') === '148') {
        // externes Rating
        this.showPG2 = true
        this.configExcel.excelSheetPG2BILANZ = Vue.prototype.storage.getState('PG2Defaultexport', 1)
      } else {
        this.configExcel.excelSheetPG2BILANZ = 0
      }
      if (Vue.prototype.$api.getModuleId() === 'banks') {
        this.configExcel.excelSheetVerflechtungHierarchisch = 1
      }

      this.isReadOnly = ('' + window.edoUserId) === '361'
      this.year = '' + this.$route.params.year
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/akte/TabDokumente.vue